import React, { useContext } from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import EnrollmentMain from '../components/Enrollment/EnrollmentMain/EnrollmentMain';

import { LoggedInUserContext } from '../components/contexts/LoggedInUserContext';
import LogoutPage from '../components/Logout/LogoutPage';
import LoginRoute from './Login/LoginRoute';
import EnrollmentCallUs from '../components/Enrollment/EnrollmentRightPane/EnrollmentCallUs/EnrollmentCallUs';
import EulaConfirmationPage from '../components/Enrollment/EnrollmentRightPane/EnrollmentFindPractice/EnrollmentEula/EulaConfirmationPage/EulaConfirmationPage';

export default function Routes(): React.ReactElement {
  return (
    <BrowserRouter>
      <RouterRoutes>
        <Route path={'/login'} element={<LoginRoute />} />
        <Route path={'/signUp'} element={<LoginRoute action={'signUp'} />} />
        <Route
          path={'/enrollment'}
          element={
            <RequireLoggedInUser>
              <EnrollmentMain />
            </RequireLoggedInUser>
          }
        />
        <Route path={'/logout'} element={<LogoutPage />} />
        <Route path={'/problem'} element={<EnrollmentCallUs />} />
        <Route
          path={'/confirmation'}
          element={
            <RequireLoggedInUser>
              <EulaConfirmationPage />
            </RequireLoggedInUser>
          }
        />
        <Route path={'/:application/login'} element={<LoginRoute />} />
        <Route path={'/:application/signUp'} element={<LoginRoute action={'signUp'} />} />
        <Route path={'/:application'} element={<LoginRoute />} />
        <Route
          path={'/'}
          element={
            <RequireLoggedInUser>
              <EnrollmentMain />
            </RequireLoggedInUser>
          }
        />
      </RouterRoutes>
    </BrowserRouter>
  );
}

function RequireLoggedInUser({ children }: { children: React.ReactElement }): React.ReactElement {
  const { loggedInUser } = useContext(LoggedInUserContext);

  return loggedInUser ? children : <LoginRoute action={'login'} />;
}
